<template>
  <div>
    <el-form
      ref="claim"
      :model="item"
      label-width="120px"
      :label-position="labelPosition"
      size="small"
      v-loading="loading"
    >
      <el-tabs v-model="activeName" plane>
        <el-tab-pane :label="$t('Məlumat')" name="claim">
          <div class="col-12" style="text-align: right">
            <el-button
              size="small"
              type="success"
              v-if="(this.claimStatus === 162 && this.item.zbtIntegrated === 0)"
              @click="changeZbtIntegratedStatus"
            >
              <i class="fa-solid fa-check"></i>
              {{ $t('ZBT_integrasiya_olundu') }}
            </el-button>
          </div>

          <div class="d-flex justify-content-center" style="padding-bottom: 10px"></div>

          <card>
            <el-form label-width="200px" :label-position="labelPosition" size="small">
              <div class="row">
                <div class="col-md-4 col-12">
                  <titles :text="$t('Hadisə_nömrəsi')"></titles>
                  <hr
                    width="85%"
                    size="50"
                    style="margin-top: 5px; position: relative; height: 1px; background: #F3EFE0;"
                    align="left"
                  />
                  <span style="font-size: var(--font-primary);">#: {{ item.dispClaimNumber }}</span>
                </div>

                <div class="col-md-4 col-12">
                  <titles text="Status"></titles>
                  <hr
                    width="85%"
                    size="50"
                    style="margin-top: 5px; position: relative; height: 1px; background: #F3EFE0;"
                    align="left"
                  />

                  <status-label
                    :type="claimParticipants.statusTypeId === 45
                      ? 'indigo'
                      : '' || claimParticipants.statusTypeId === 50
                        ? 'forestGreen'
                        : '' || claimParticipants.statusTypeId === 51
                          ? 'red'
                          : '' || claimParticipants.statusTypeId === 70
                            ? 'goldenrod'
                            : '' || claimParticipants.statusTypeId === 75
                              ? 'limeGreen'
                              : '' || claimParticipants.statusTypeId === 80
                                ? 'mediumBlue'
                                : '' || claimParticipants.statusTypeId === 95
                                  ? 'greenYellow'
                                  : '' || claimParticipants.statusTypeId === 110
                                    ? 'coral'
                                    : '' || claimParticipants.statusTypeId === 125
                                      ? 'salmon'
                                      : '' || claimParticipants.statusTypeId === 130
                                        ? 'olive'
                                        : '' || claimParticipants.statusTypeId === 131
                                          ? 'lightblue'
                                          : '' || claimParticipants.statusTypeId === 135
                                            ? 'forestGreen'
                                            : '' || claimParticipants.statusTypeId === 140
                                              ? 'greenYellow'
                                              : '' || claimParticipants.statusTypeId === 141
                                                ? 'goldenrod'
                                                : '' || claimParticipants.statusTypeId === 152
                                                  ? 'red'
                                                  : '' || claimParticipants.statusTypeId === 153
                                                    ? 'red'
                                                    : ''
                    "
                  />
                  <span style="font-size: var(--font-primary);">{{ claimParticipants.statusTypeName }}</span>
                </div>
              </div>

              <br />

              <card v-if="claimParticipants.clientServiceFinishDate">
                <div class="row">
                  <div class="col-md-4 col-12">
                    <span style="font-size: var(--font-primary);">
                      <span style="font-weight: bold;">{{$t('Xitam_edən')}}</span>
                      {{ claimParticipants.clientServiceFinishUserName }}
                    </span>
                  </div>

                  <div class="col-md-4 col-12">
                    <span style="font-size: var(--font-primary);">
                      <span style="font-weight: bold;">{{$t('Xitam_səbəbi_')}}</span>
                      {{ claimParticipants.clientServiceFinishNote }}
                    </span>
                  </div>

                  <div class="col-md-4 col-12">
                    <span style="font-size: var(--font-primary);">
                      <span style="font-weight: bold;">{{$t('Xitam_vaxtı_')}}</span>
                      {{ claimParticipants.clientServiceFinishDateStr }}
                    </span>
                  </div>
                </div>
              </card>
            </el-form>
          </card>

          <div>
            <el-button
              size="small"
              class="primary"
              style="margin-top: -30px; margin-bottom: 10px;"
              slot="append"
              icon="fa-solid fa-right-left"
              @click="changeClaimVictim"
            >
              {{ $t('Zərərçəkəni_dəyişdir') }}
            </el-button>

            <el-button
              size="small"
              class="primary"
              style="margin-top: -30px; margin-bottom: 10px;"
              slot="append"
              icon="fa-solid fa-percent"
              v-if="item.damageCategoryId !== 2"
              @click="proportionalDivisionUpdate"
            >
              {{ $t('Proporsional_bölgünü_yenilə') }}
            </el-button>
          </div>

          <card>
            <el-form label-width="200px" :label-position="labelPosition" size="small" v-loading="claimLoading">
              <titles :text="$t('Hadisə_məlumatları')"></titles>
              <hr
                width="100%"
                size="50"
                style="margin-top: 5px; position: relative; height: 1px; background: #F3EFE0;"
                align="center"
              />

              <div class="row">
                <div class="col-md-6 col-12">
                  <el-form-item :label="$t('Sığorta_məbləği')" v-if="item.policyType !== 1" prop="insuredSum">
                    <el-input type="number" v-model="item.insuredSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('Sığorta_haqqı')" v-if="item.policyType !== 1" prop="premium">
                    <el-input type="number" v-model="item.premium"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('Ödənməmiş_sığorta_haqqı')" v-if="item.policyType !== 1" prop="debt">
                    <el-input type="number" v-if="item.policyType !== 1" v-model="item.debt"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ZBT')" v-if="item.policyType && item.policyType === 1" prop="zbt">
                    <el-radio-group
                      @change="radioChange('zbt')"
                      :disabled="item.commChainAccident === 1 || item.commInjured === 1"
                      v-model="item.zbt"
                    >
                      <el-radio :label="1">{{ $t('Bəli') }}</el-radio>
                      <el-radio :label="0">{{ $t('Xeyr') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item
                    :label="$t('Zəncirvari_qəza')"
                    v-if="item.policyType && item.policyType === 1"
                    prop="chainAccident"
                  >
                    <el-radio-group
                      @change="radioChange('chainAccident')"
                      :disabled="item.zbt === 1"
                      v-model="item.chainAccident"
                    >
                      <el-radio :label="1">{{ $t('Bəli') }}</el-radio>
                      <el-radio :label="0">{{ $t('Xeyr') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item
                    :label="$t('Xəsarət_alan')"
                    v-if="item.policyType && item.policyType === 1"
                    prop="injured"
                  >
                    <el-radio-group @change="radioChange('injured')" :disabled="item.zbt === 1" v-model="item.injured">
                      <el-radio :label="1">{{ $t('Var') }}</el-radio>
                      <el-radio :label="0">{{ $t('Yoxdur') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item
                    :label="$t('Daxili_protokol')"
                    v-if="item.policyType && item.policyType === 1"
                    prop="protocol"
                  >
                    <el-radio-group
                      @change="radioChange('protocol')"
                      :disabled="item.commInjured === 1"
                      v-model="item.protocol"
                    >
                      <el-radio :label="1">{{ $t('Bəli') }}</el-radio>
                      <el-radio :label="0">{{ $t('Xeyr') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item :label="$t('Subroqasiya')" prop="subragation">
                    <el-radio-group @change="radioChange('subragation')" v-model="item.subragation">
                      <el-radio :label="1">{{ $t('Var') }}</el-radio>
                      <el-radio :label="0">{{ $t('Yoxdur') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item
                    :label="$t('F4_verilmə_tarixi')"
                    v-if="oSdamageType !== 2 && item.policyType && item.policyType === 1"
                    disabled
                    prop="f4IssueDate"
                  >
                    <el-date-picker
                      type="date"
                      :placeholder="$t('F4_verilmə_tarixi')"
                      v-model="item.f4IssueDate"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                </div>

                <div class="col-md-6 col-12">
                  <el-form-item :label="$t('Azadolma_məbləği')" v-if="item.policyType !== 1" prop="deductible">
                    <el-input type="number" v-model="item.deductible"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('Əlavə_azadolma_məbləği')" v-if="item.policyType !== 1" prop="deductibleAdd">
                    <el-input type="number" v-model="item.deductibleAdd"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('Ümumi_müqavilə_üzrə_borc')" v-if="item.policyType !== 1" prop="contractDebt">
                    <el-input type="number" v-model="item.contractDebt" v-if="item.policyType !== 1"></el-input>
                  </el-form-item>

                  <el-form-item label="Zərər vuran " v-if="roles.includes('DevTest')" prop="victim">
                    <el-select
                      style="width: 100%"
                      :placeholder="$t('Seçin')"
                      v-model="item.victim"
                      @change="onVictimChange"
                    >
                      <el-option :label="$t('Sığortalı')" :value="1"></el-option>
                      <el-option :label="$t('Qarşı_tərəf')" :value="2"></el-option>
                      <el-option :label="$t('Naməlum')" :value="3"></el-option>
                      <el-option :label="$t('Hər_iki_tərəf')" :value="4"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    v-if="(item.paymentSum || item.paymentSum !== 0) && item.damageCategoryId !== 2"
                    :label="$t('Zərərçəkən_hər_iki_tərəf')"
                    prop="bothVictim"
                  >
                    <el-checkbox
                      :true-label="1"
                      @change="onVictimChange"
                      :false-label="0"
                      v-model="item.bothVictim"
                    ></el-checkbox>
                  </el-form-item>

                  <el-form-item
                    v-if="item.policyType && item.policyType === 1"
                    :label="$t('NV_sayı')"
                    prop="vehicleCount"
                  >
                    <el-input-number :disabled="item.zbt === 1" v-model="item.vehicleCount" :min="1" :max="10" />
                  </el-form-item>

                  <el-form-item :label="$t('Hadisənin_səbəbi')" prop="damageCategoryId">
                    <damage-categories
                      :damageType="item.policyType === 1 ? claimParticipants.osDamageType : 3"
                      v-model="item.damageCategoryId"
                    />
                  </el-form-item>

                  <el-form-item
                    :label="$t('Xəsarətin_dərəcəsi')"
                    prop="medDamageType"
                    v-if="item.damageCategoryId === 2"
                  >
                    <med-damage-types v-model="item.medDamageType" />
                  </el-form-item>
                </div>
              </div>

              <titles :text="$t('Faydalanan')"></titles>
              <hr
                width="100%"
                size="50"
                style="margin-top: 5px; position: relative; height: 1px; background: #F3EFE0;"
                align="center"
              />

              <div class="row">
                <div class="col-md-6 col-12">
                  <div style="display: flex;">
                    <div style="flex: 1; margin-right: -100px;">
                      <el-form-item>
                        <el-radio-group v-model="item.paymentPersonType">
                          <el-radio :label="1">{{ $t('FİN') }}</el-radio>
                          <el-radio :label="2">{{ $t('VÖEN') }}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </div>

                    <div style="flex: 1.2">
                      <el-form-item prop="paymentIdentNumber">
                        <el-input id="search" v-model="item.paymentIdentNumber" style="width: 100%;">
                          <span slot="append">&nbsp;</span>
                          <el-button
                            class="primary"
                            size="small"
                            slot="append"
                            icon="el-icon-search"
                            @click="item.paymentPersonType === 1 ? onSearchAsan('PersonalInfo') : onSearchAsan('VoenInfo')"
                          >
                          </el-button>
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12"></div>
              </div>

              <div class="row">
                <div class="col-md-6 col-12">
                  <el-form-item :label="$t('Faydalanan_şəxs')" prop="paymentReceivedPerson">
                    <el-input v-model="item.paymentReceivedPerson"></el-input>
                  </el-form-item>
                </div>

                <div class="col-md-6 col-12">
                  <el-form-item :label="$t('Faydalananın_əlaqə_№')" prop="paymentReceivedPersonPhone">
                    <phone v-model="item.paymentReceivedPersonPhone" />
                  </el-form-item>
                </div>
              </div>

              <titles v-if="item.damageCategoryId !== 1 && item.policyType === 1" text="Xəsarət alan"></titles>
              <hr
                v-if="item.damageCategoryId !== 1 && item.policyType === 1"
                width="100%"
                size="50"
                style="margin-top: 5px; position: relative; height: 1px; background: #F3EFE0;"
                align="center"
              />

              <div class="row" v-if="item.damageCategoryId !== 1 && item.policyType === 1">
                <div class="col-md-6 col-12">
                  <el-form-item v-if="item.damageCategoryId && item.damageCategoryId !== 1" ::label="$t('getIdentLabelName')" prop="identNumber">
                    <el-input id="search" v-model="item.partIdentNumber" style="width: 100%;">
                      <span slot="append">&nbsp;</span>
                      <el-button class="primary" size="small" slot="append" icon="el-icon-search" @click="onSearchPersonalInfo">
                      </el-button>
                    </el-input>
                  </el-form-item>
                </div>
                <div class="col-md-6 col-12"></div>
              </div>

              <div class="row" v-if="item.damageCategoryId !== 1 && item.policyType === 1">
                <div class="col-md-6 col-12">
                  <el-form-item v-if="item.damageCategoryId && item.damageCategoryId !== 1" ::label="$t('getPartPersonLabel')" prop="partPersonName">
                    <el-input v-model="item.partPersonName"></el-input>
                  </el-form-item>

                  <el-form-item
                    v-if="item.damageCategoryId && item.damageCategoryId !== 1 && item.damageCategoryId !== 2"
                    :label="$t('Əmlak_adı')"
                    prop="propertyName"
                  >
                    <el-input v-model="item.propertyName"></el-input>
                  </el-form-item>
                </div>

                <div class="col-md-6 col-12">
                  <el-form-item v-if="item.damageCategoryId && item.damageCategoryId !== 1" ::label="$t('getPartPersonPhoneLabel')" prop="partPersonPhone">
                    <phone v-model="item.partPersonPhone" />
                  </el-form-item>
                </div>
              </div>

              <titles :text="$t('Ödəniş_məlumatları')"></titles>
              <hr
                width="100%"
                size="50"
                style="margin-top: 5px; position: relative; height: 1px; background: #F3EFE0;"
                align="center"
              />

              <div class="row">
                <div class="col-md-6 col-12">
                  <el-form-item :label="$t('Ödənilmə_qaydası')" prop="paymentRule">
                    <el-select style="width: 100%" :placeholder="$t('Seçin')" size="small" v-model="item.paymentRule">
                      <el-option :label="$t('Bank_hesabı')" :value="2"></el-option>
                      <el-option :label="$t('Kart')" :value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <div class="col-md-6 col-12">
                  <el-form-item :label="$t('Yekun_məbləğ')" prop="paymentSum">
                    <el-input v-if="item.damageCategoryId === 2" v-decimal :disabled="true" v-model="paymentSumComputed"></el-input>
                    <el-input v-else v-decimal :disabled="true" v-model="paymentSum"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-12">
                  <el-form-item :label="$t('Əlavə_qeyd')" prop="otherDescr">
                    <el-input v-model="item.otherDescr" resize="none" type="textarea" :rows="2"></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form>

            <div class="col-12 mb-3" style="text-align: right; margin-left: 13px;">
              <el-button size="small" type="primary" @click="save">{{ $t('Yadda_saxla') }}</el-button>
            </div>
          </card>

          <el-collapse v-loading="loading" value="4">
            <el-collapse-item name="4">
              <template slot="title" style="color: black;">
                <i class="fa-solid fa-people-group"></i>
                &nbsp;
                <span>{{ $t('Hadisə_tərəfləri') }}</span>
              </template>
              <claim-participant-base :value="claimParticipants" />
            </el-collapse-item>
          </el-collapse>

          <el-collapse v-loading="loading" value="1">
            <el-collapse-item name="1">
              <template #title>
                <div style="margin-left: 7px;">
                  <i class="fa-solid fa-headphones-simple"></i>
                  &nbsp;
                  <span>{{ $t('Çağrı_mərkəzinin_qeydləri') }}</span>
                </div>
              </template>
              <accident-base :value="accItem"></accident-base>
            </el-collapse-item>
          </el-collapse>

          <el-collapse v-loading="loading" value="2">
            <el-collapse-item name="2">
              <template #title>
                <div style="margin-left: 7px;">
                  <i class="fa-solid fa-person-military-pointing"></i>
                  &nbsp;
                  <span>{{ $t('Komissarın_qeydləri') }}</span>
                </div>
              </template>
              <accident-comm-base :value="comm"></accident-comm-base>
            </el-collapse-item>
          </el-collapse>

          <el-collapse v-loading="loading" value="3">
            <el-collapse-item name="3">
              <template #title>
                <div style="margin-left: 7px;">
                  <i class="fa-solid fa-people-arrows-left-right"></i>
                  &nbsp;
                  <span>{{ $t('İştirakçılar') }}</span>
                </div>
              </template>

              <card>
                <el-form v-loading="partloading">
                  <div class="row">
                    <div class="col-md-6 col-12" v-for="item in participants" :key="item.id">
                      <div v-if="item.policyType === null || item.policyType === 1">
                        <participant-card
                          :item="item"
                          @refresh="getParticipants"
                          @edit="editParticipant(item.id)"
                          @delete="deleteParticipant"
                          @report="reportParticipant(item.id)"
                        />
                      </div>
                      <div v-else>
                        <other-participant-card
                          :item="item"
                          @refresh="getParticipants"
                          @edit="editParticipant(item.id)"
                          @delete="deleteParticipant"
                          @report="reportParticipant(item.id)"
                        />
                      </div>
                    </div>
                  </div>
                </el-form>
              </card>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>

        <el-tab-pane name="claimdoc" :label="$t('Sənədlər')">
          <div>
            <claim-docs v-if="item.id" :id="item.id"></claim-docs>
          </div>
        </el-tab-pane>

        <el-tab-pane
          name="expert"
          v-if="item.damageType !== 2 && this.claimParticipants.osDamageType !== 2"
          :label="$t('Qiymətləndirmə')"
        >
          <div>
            <div class="row">
              <div class="col-md-10 col-12">
                <div style="padding-bottom: 10px">
                  <el-button size="small" type="warning" @click="onSendTechExpert" v-if="!this.techExpertStatus">
                    <i class="el-icon-circle-check"></i>&nbsp;Qiymətləndirməyə göndər
                  </el-button>

                  <div v-else>
                    <span style="background-color:#8E9A9B; color: white; padding:5px;">
                      {{
                        "İş texniki ekspertizaya göndərilmişdir: " +
                        (techExpertStatus && techExpertStatus.createdBy ? techExpertStatus.createdBy : '')
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="this.techExpertStatus">
              <assessments @refresh="getClaimTechExpert" :claimId="Number(this.id)" :readonly="false" />
            </div>

            <div v-if="this.techExpertStatus">
              <internal-evaluation @refresh="getData" :value="expertItem || {}" :readonly="true" :policyType="item.policyType" />
            </div>

            <div v-if="this.techExpertStatus && this.item.policyType === 1">
              <service-evaluation @refresh="getClaimTechExpert" :readonly="true" :value="expertItem || {}" />
            </div>

            <div v-if="this.techExpertStatus">
              <indepentend-evaluation @refresh="getClaimTechExpert" :readonly="true" :value="expertItem || {}" />
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane
          name="act"
          v-if="(this.claimStatus >= 139) || (this.claimParticipants.osDamageType === 2)"
          :label="$t('Hesab_məlumatları')"
        >
          <div>
            <div class="row">
              <div style="margin-bottom: 10px;" class="col-10">
                <!-- FIX: act object/null => act.length yok -->
                <el-button size="small" type="warning" @click="onStartAct" v-if="!this.act">
                  <i class="fa-solid fa-play"></i>
                  {{ $t('Qəbul_et_və_başla') }}
                </el-button>

                <div v-else>
                  <span style="background-color:#8E9A9B; color: white; padding:5px;">
                    {{
                      "Hesab məlumatlarının daxil edilməsi başlanmışdır: " +
                      (act && act.createdBy ? act.createdBy : '')
                    }}
                  </span>
                  <br />
                </div>
              </div>
            </div>

            <!-- FIX: act object/null => act.length yok -->
            <bank-account-info
              :value="this.act"
              v-if="this.act"
              @refresh="getData"
              :actPrint="this.actPrint"
              :policyType="item.policyType"
            />

            <div class="row" style="text-align: right">
              <div class="col-12"></div>
            </div>
          </div>
          <br />
        </el-tab-pane>

        <el-tab-pane name="aprrove" :label="$t('Təsdiqlənmə')">
          <card v-if="this.claimStatus === 153">
            <div>
              <h5>{{$t('Ödənişdən_geri_qaytarılıb')}}</h5>
              <br />
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in rejectClaim"
                  :key="index"
                  :icon="activity.icon"
                  :type="activity.type"
                  :color="'#B3005E'"
                  :size="activity.size"
                  :timestamp="formatDateTime(activity.createDate)"
                >
                  <span style="font-size: var(--font-primary);">{{$t('Geri_qaytaran_1')}}</span>{{ activity.createUserName }}
                  <br />
                  <span style="font-size: var(--font-primary);">{{ $t('Səbəb') }}: </span>{{ activity.reason }}
                </el-timeline-item>
              </el-timeline>
            </div>
          </card>

<div class="row" style="margin-bottom: 10px;">
  <div class="col-10">
    <el-button
      size="small"
      type="warning"
      @click="handleApprove"
      v-if="claimStatus === 150 || claimStatus === 152 || claimStatus === 153"
    >
      <i class="fa-solid fa-play"></i>
      {{ $t('Təsdiqlənməyə_göndər') }}
    </el-button>

    <div v-else>
      <span
        v-if="act && act.createdBy"
        style="background-color:#8E9A9B; color:white; padding:5px;"
      >
        {{ `Təsdiqlənməyə göndərilmişdir ${act.createdBy}` }}
      </span>
      <br />
    </div>
  </div>
</div>


          <card v-if="this.claimStatus >= 150">
            <div>
              <signers ref="signersComponent" v-if="item.id" :value="item.id"></signers>
            </div>
          </card>
        </el-tab-pane>

        <el-tab-pane name="payment" :label="$t('Ödəniş')">
          <card>
            <div></div>
          </card>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <participant ref="participant" @saved="getParticipants" />
    <report-participant ref="report" @saved="getParticipants" />
    <other-participant ref="otherParticipant" @saved="getParticipants" />
  </div>
</template>

<script>
  import Phone from "../components/Phone.vue";
  import ClaimParticipantBase from "../components/ClaimParticipantBase.vue";
  import InternalEvaluation from '../components/InternalEvaluation.vue';
  import ServiceEvaluation from "../components/ServiceEvaluation.vue";
  import IndepentendEvaluation from '../components/IndepentendEvaluation.vue';
  import StatusLabel from "../components/StatusLabel.vue";
  import DamageCategories from "../components/DamageCategories.vue";
  import BankAccountInfo from '../components/BankAccountInfo.vue';
  import ClaimDocs from "../components/ClaimDocs.vue";
  import Signers from "../components/Signers.vue";
  import Assessments from "../components/Assessments.vue";
  import MedDamageTypes from "../components/MedDamageTypes.vue";
  import Participant from "../components/Participant.vue";
  import ParticipantCard from "../components/ParticipantCard.vue";
  import OtherParticipantCard from "../components/OtherParticipantCard.vue";
  import OtherParticipant from "../components/OtherParticipant.vue";
  import AccidentBase from "../components/AccidentBase.vue";
  import AccidentCommBase from "../components/AccidentCommBase.vue";
  import ReportParticipant from "../components/ReportParticipant.vue";
  import Titles from "../components/Titles.vue";

  import html2canvas from "html2canvas";
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  import { api, labelPosition, formatDateTime } from "../../services/helper";
  import { GetParticipants, GetAccidentsByStatus, GetAccident, GetCommData } from "../../services/accident";
  import { asanapi } from "../../services/sales";

  import {
    GetClaimParticipant,
    GetClaimActPrint,
    CheckStatusCount,
    LastAssessmentStatus
  } from "../../services/common";

  import {
    GetClaim,
    UpdateClaim,
    DeleteClaimDoc,
    SendToTechExpert,
    GetClaimTechExpert,
    CreateClaimAct,
    GetClaimAct,
    SendToApprove,
    ChangeClaimVictim,
    ProportionalDivisionUpdate,
    ChangeZbtIntegratedStatus,
    GetPaymentReject,
    LastClaimStatus
  } from "../../services/claim";

  import { CreateSubrogation, GetSubrogation } from "../../services/subrogations";

  export default {
    components: {
      ClaimDocs,
      ClaimParticipantBase,
      StatusLabel,
      InternalEvaluation,
      ServiceEvaluation,
      IndepentendEvaluation,
      DamageCategories,
      BankAccountInfo,
      Signers,
      Assessments,
      MedDamageTypes,
      Phone,
      AccidentBase,
      AccidentCommBase,
      Participant,
      ReportParticipant,
      ParticipantCard,
      OtherParticipantCard,
      OtherParticipant,
      Titles
    },
    props: {
      id: [String, Number],
    },
    data() {
      return {
        activeName: "claim",
        loading: false,
        claimLoading: false,

        item: {},
        participants: [],
        claimdocs: [],
        accItem: {},

        claimParticipants: {},
        techExpertStatus: null,
        legalExpertStatus: null,
        expertItem: {},

        actLoading: false,
        act: null, // FIX: object/null
        actPrint: {},

        claimStatus: {},
        oSdamageType: 1,

        statusCount: 0,
        uid: this.$store.state.user.id,
        roles: this.$store.state.user.roles,

        asanData: {
          Personal: {},
          Voen: {},
        },

        assessmentStatus: null,
        printDialogVisible: false,

        comm: {},
        commloading: false, // FIX: vardı ama data'da yoktu
        partloading: false,

        isDivided: false,
        paymentSum: null,

        rejectClaim: [],
        dialogVisible: false,

        showSubrogationTab: false,
        subrogationCreated: false,

        labelPosition: labelPosition,
      };
    },
    computed: {
      paymentSumComputed() {
        const baseAmount = 5000;
        switch (this.item.medDamageType) {
          case 1: return (baseAmount * 15) / 100;
          case 2:
          case 3: return (baseAmount * 30) / 100;
          case 4: return (baseAmount * 100) / 100;
          case 5: return (baseAmount * 80) / 100;
          case 6: return (baseAmount * 60) / 100;
          case 7: return (baseAmount * 40) / 100;
          default: return 0;
        }
      },
      getPartPersonLabel() {
        if (this.item.damageCategoryId === 1) return null;
        if (this.item.damageCategoryId === 2) return this.$t('Xəsarətalanşəxs');
        return this.$t('Əmlaksahibininadı');
      },
      getIdentLabelName() {
        if (this.item.damageCategoryId === 1) return null;
        if (this.item.damageCategoryId === 2) return this.$t('XəsarətalanınFN');
        return this.$t('ƏmlaksahibininFN');
      },
      getPartPersonPhoneLabel() {
        if (this.item.damageCategoryId === 1) return null;
        if (this.item.damageCategoryId === 2) return this.$t('Xəsarətalanınəlaqənömrəsi');
        return this.$t('Əmlaksahibininəlaqənömrəsi');
      },
    },
    methods: {
      formatDateTime,

      async submitSubrogation() {
        try {
          const subrogationData = {
            accidentId: this.item.accidentId,
            claimId: this.item.id,
            subrogationAmount: this.item.paymentSum,
          };
          await CreateSubrogation(subrogationData);
          this.$message({ type: "success", message: this.$t('Uğurlu_Əməliyyat') });
          this.subrogationCreated = true;
          this.checkSubrogation();
        } catch (error) {
          console.error("Failed to create subrogation:", error);
        }
      },

      checkSubrogation() {
        if (this.item.subragation === 1) {
          this.showSubrogationTab = true;
          GetSubrogation(this.item.id)
            .then((response) => {
              if (response.data) this.subrogationCreated = true;
            })
            .catch((error) => {
              console.error("Error checking subrogation:", error);
            });
        } else {
          this.showSubrogationTab = false;
          this.subrogationCreated = false;
          this.activeName = "claim";
        }
      },

      showDialog() {
        this.dialogVisible = true;
      },

      getClaimActPrint() {
        GetClaimActPrint(this.id).then((response) => {
          if (response.data) {
            this.actPrint = response.data.data?.[0] || {};
          }
        });
      },

      onVictimChange(value) {
        // minimal: mevcut mantığı bozmadan güvenli hale
        if (value === 1) {
          if (typeof this.paymentSum === "number") this.paymentSum = this.paymentSum / 2;
        } else {
          this.paymentSum = this.item.paymentSum;
        }
      },

      onSearchAsan(asanType) {
        this.loading = true;
        const number = this.item.paymentIdentNumber;

        asanapi(asanType, number, this.uid)
          .then((response) => {
            if (!response.data.response) {
              this.$message({ type: "error", message: this.$t('Məlumatların_tam_və_düzgün_olmasını_yoxlayın') });
            } else {
              switch (asanType) {
                case 'PersonalInfo':
                  this.asanData.Personal = response.data.response;
                  this.item.paymentReceivedPerson = `${this.asanData.Personal.surname} ${this.asanData.Personal.name} ${this.asanData.Personal.patronymic}`;
                  break;
                case 'VoenInfo':
                  this.asanData.Voen = response.data.response;
                  this.item.paymentReceivedPerson = this.asanData.Voen.legalEntity.fullName;
                  break;
              }
            }
            this.loading = false;
          })
          .catch(() => {
            this.$message({ type: "error", message: this.$t('Zəhmət_olmasa_yenidən_cəhd_edin') });
            this.loading = false;
          });
      },

      onSearchPersonalInfo() {
        const number = this.item.partIdentNumber;
        this.loading = true;

        asanapi('PersonalInfo', number, this.uid)
          .then((response) => {
            if (!response.data.response) {
              this.$message({ type: "error", message: this.$t('Məlumatların_tam_və_düzgün_olmasını_yoxlayın') });
            } else {
              this.asanData.Personal = response.data.response;
              this.item.partPersonName = `${this.asanData.Personal.surname} ${this.asanData.Personal.name} ${this.asanData.Personal.patronymic}`;
            }
            this.loading = false;
          })
          .catch(() => {
            this.$message({ type: "error", message: this.$t('Zəhmət_olmasa_yenidən_cəhd_edin') });
            this.loading = false;
          });
      },

      onSendTechExpert() {
        this.checkStatusCount(this.id, 70).then(() => {
          if (this.statusCount > 0) {
            this.$message({ type: "warning", message: this.$t('Daha_öncə_qiymətləndirməyə_göndərilib') });
          } else {
            this.$confirm(this.$t('Qiymətləndirməyə_göndərilsin'), this.$t('Təsdiqləyin'), {
              confirmButtonText: this.$t('Bəli'),
              cancelButtonText: this.$t("Xeyr"),
              type: "info",
            })
              .then(() => {
                this.loading = true;
                SendToTechExpert(this.id, this.uid).then((response) => {
                  this.loading = false;
                  if (response.data) {
                    if (!response.data.isSuccess) {
                      this.$message({ type: "error", message: response.data.errors[0] });
                    } else {
                      this.$message({ type: "success", message: this.$t('Qiymətləndirməyə_göndərildi') });
                      this.getData();
                    }
                  } else {
                    this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
                  }
                });
              })
              .catch(() => {
                this.loading = false;
                this.$message({ type: "info", message: "Xitam verildi" });
              });
          }
        });
      },

      async print() {
        this.printDialogVisible = true;
      },

      getCommData() {
        this.commloading = true;
        GetCommData(this.item.accidentId).then((response) => {
          this.commloading = false;
          if (response.data) {
            this.comm = response.data.data?.[0] || {};
          } else {
            this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
          }
        });
      },

      async exportPDF() {
        // FIX: originalTransform tanımsızdı + ref yoksa crash olmasın
        const content = this.$refs.printMeRef;
        if (!content) {
          this.$message({ type: "warning", message: this.$t('Print_bölməsi_tapılmadı_ref_printMeRef') });
          return;
        }

        const originalTransform = content.style.transform;
        try {
          const canvas = await html2canvas(content);
          const imgData = canvas.toDataURL("image/png");

          const pdfDoc = {
            content: [{ image: imgData, width: 500 }],
          };

          pdfMake.createPdf(pdfDoc).getBlob(async (blob) => {
            const url = URL.createObjectURL(blob);
            window.open(url);

            const formData = new FormData();
            formData.append("file", blob, this.item.dispClaimNumber + ".pdf");

            try {
              await fetch(api + "/Upload", {
                method: "POST",
                headers: { Accept: "application/json" },
                body: formData,
              });
            } catch (e) {
              console.error(e);
            } finally {
              content.style.transform = originalTransform;
            }
          });
        } catch (e) {
          console.error(e);
          content.style.transform = originalTransform;
        }
      },

      deleteParticipant(id) {
        // sende boştu, dokunmuyorum
      },

      checkStatusCount(id, status) {
        this.statusCount = 0;
        return new Promise((resolve, reject) => {
          CheckStatusCount(0, id, status).then(
            (response) => {
              if (response.data) this.statusCount = response.data;
              resolve(true);
            },
            (error) => reject(error)
          );
        });
      },

      onStartAct() {
        this.$confirm(this.$t('Hesab_məlumatlarının_daxil_edilməsi_başlanır'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t("Xeyr"),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        }).then(() => {
          CreateClaimAct(this.id, this.uid).then((response) => {
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({ type: "error", message: response.data.errors[0] });
              } else {
                this.$message({ type: "success", message: this.$t('Uğurlu_əməliyyat') });
                this.getData();
              }
            } else {
              this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
            }
          });
        });
      },

      editParticipant(id) {
        if (this.item.policyType === 1 && this.item.policyType) this.$refs["participant"].edit(id, false);
        else this.$refs["otherParticipant"].edit(id, false);
      },

      getPaymentReject() {
        GetPaymentReject(this.id, 4).then((response) => {
          this.loading = false;
          if (response.data) this.rejectClaim = response.data.data || [];
        });
      },

      reportParticipant(id, accidentId, createUserId) {
        this.$refs["report"].edit(id, accidentId, createUserId);
      },

      handleApprove() {
        if (!this.paymentSum || this.paymentSum === "" || this.paymentSum === 0) {
          this.$message({ type: "warning", message: this.$t('Ödəniş_məbləği_qeyd_olunmayıb') });
          return;
        }
        if (!this.item.paymentReceivedPerson || this.item.paymentReceivedPerson.trim() === "") {
          this.$message({ type: "warning", message: this.$t('Ödəniş_alacaq_şəxs_qeyd_olunmayıb') });
          return;
        }

        // FIX: act null iken patlamasın
        if (!this.act || !this.act.accountNumber || this.act.accountNumber.trim() === "") {
          this.$message({ type: "warning", message: this.$t('Hesab_nömrəsi_əlavə_edilməyib') });
          return;
        }

        this.checkStatusCount(this.id, 151).then(() => {
          if (this.statusCount > 0) {
            this.$message({ type: "warning", message: this.$t('Daha_öncə_Təsdiqlənməyə_göndərilib') });
          } else {
            this.$confirm(this.$t('Təsdiqlənməyə_göndərilsin'), this.$t('Təsdiqləyin'), {
              confirmButtonText: this.$t('Bəli'),
              cancelButtonText: this.$t("Xeyr"),
              type: "info",
            })
              .then(() => {
                this.actloading = true;
                SendToApprove(this.id, this.uid).then((response) => {
                  this.actloading = false;
                  if (response.data) {
                    if (!response.data.isSuccess) {
                      this.$message({ type: "error", message: response.data.errors[0] });
                    } else {
                      this.$message({ type: "success", message: this.$t('Uğurlu_əməliyyat') });
                      if (this.$refs.signersComponent && this.$refs.signersComponent.refreshSigners) {
                        this.$refs.signersComponent.refreshSigners();
                      }
                      this.getData();
                    }
                  } else {
                    this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
                  }
                });
              })
              .catch(() => {
                this.loading = false;
                this.$message({ type: "info", message: "Xitam verildi" });
              });
          }
        });
      },

      changeClaimVictim() {
        ChangeClaimVictim(this.id, this.uid).then((response) => {
          this.actloading = false;
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({ type: "error", message: response.data.errors[0] });
            } else {
              this.$message({ type: "success", message: this.$t('Uğurlu_əməliyyat') });
              this.getData();
            }
          } else {
            this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
          }
        });
      },

      proportionalDivisionUpdate() {
        ProportionalDivisionUpdate(this.id, this.uid).then((response) => {
          this.actloading = false;
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({ type: "error", message: response.data.errors[0] });
            } else {
              this.$message({ type: "success", message: this.$t('Uğurlu_əməliyyat') });
              this.getData();
            }
          } else {
            this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
          }
        });
      },

      changeZbtIntegratedStatus() {
        ChangeZbtIntegratedStatus(this.id, this.uid).then((response) => {
          this.actloading = false;
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({ type: "error", message: response.data.errors[0] });
            } else {
              this.$message({ type: "success", message: this.$t('Uğurlu_əməliyyat') });
              this.getData();
              this.$router.push("../zbt-claims/");
            }
          } else {
            this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
          }
        });
      },

      getClaimTechExpert() {
        GetClaimTechExpert(this.id).then((response) => {
          if (response.data) {
            this.expertItem = response.data.data?.[0] || {};
            this.lastAssessmentStatus();
          }
        });
      },

      async getClaimAct() {
        try {
          const response = await GetClaimAct(this.id);
          this.act = response.data.data?.[0] || null; // FIX: object/null
        } catch (error) {
          this.$message({ type: "error", message: this.$t('Hesab_məlumatları_gətirilərkən_səhv_baş_verdi') });
          this.act = null;
        }
      },

      async getStatusTechExpert() {
        try {
          const response = await GetAccidentsByStatus(0, this.id, 70, this.uid);
          this.techExpertStatus = response.data.data?.[0] || null;
        } catch (error) {
          this.$message({ type: "error", message: this.$t('Texniki_ekspert_statusu_gətirilərkən_səhv_baş_verd') });
          this.techExpertStatus = null;
        }
      },

      lastAssessmentStatus() {
        return new Promise((resolve, reject) => {
          LastAssessmentStatus(this.id).then(
            (response) => {
              if (response.data) this.assessmentStatus = response.data;
              resolve(true);
            },
            (error) => reject(error)
          );
        });
      },

      inputInsurance(e) {
        this.$emit("input", e);
        this.item.insuranceParticipantId = e;
      },

      inputOs(e) {
        this.$emit("input", e);
        this.item.osParticipantId = e;
      },

      getParticipants() {
        // item.accidentId yoksa boş geç
        if (!this.item || !this.item.accidentId) return;

        this.partloading = true;
        GetParticipants(this.item.accidentId).then((response) => {
          this.partloading = false;
          if (response.data) this.participants = response.data.data || [];
        });
      },

      checkServiceCenterId() {
        if (!this.participants || this.participants.length === 0) return false;
        const typeOneParticipants = this.participants.filter((p) => p.participantType === 1);
        if (typeOneParticipants.length === 0) return false;
        return !!typeOneParticipants[0].serviceCenterId;
      },

      saved() {
        // sende getClaimDocs yok; dokunmuyorum
      },

      save() {
        this.claimLoading = true;
        this.item.commandUserId = this.uid;

        // FIX: paymentSum nullsa da gönderme kontrolü
        this.item.paymentSum = this.paymentSum;
        if (this.item.damageCategoryId === 2) this.item.paymentSum = this.paymentSumComputed;

        UpdateClaim(this.item).then((response) => {
          this.claimLoading = false;
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0] ? response.data.errors[0] : this.$t('Səhv_əməliyyat'),
              });
            } else {
              this.$message({ type: "success", message: this.$t('Uğurlu_əməliyyat') });
              this.getClaimAct();
              this.getClaimActPrint();
              this.checkSubrogation();
            }
          } else {
            this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
          }
        });
      },

      getAccident() {
        if (!this.item || !this.item.accidentId) return;

        this.loading = true;
        GetAccident(this.item.accidentId).then((response) => {
          this.loading = false;
          if (response.data) {
            this.accItem = response.data.data?.[0] || null;
          } else {
            this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
          }
        });
      },

      async getData() {
        const currentTab = this.activeName;

        this.loading = true;
        try {
          const response = await GetClaim(this.id);
          this.loading = false;

          if (response.data) {
            this.item = response.data.data?.[0] || {};
            this.paymentSum = this.item.paymentSum;

            this.getParticipants();
            this.getClaimParticipant();
            this.getStatusTechExpert();
            this.getClaimTechExpert();
            this.getClaimAct();
            this.getClaimActPrint();
            this.lastAssessmentStatus();
            this.getCommData();
            this.getAccident();
            this.getPaymentReject();

            this.checkSubrogation();
            await this.lastClaimStatus();

            this.activeName = currentTab;
          } else {
            this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
          }
        } catch (error) {
          this.loading = false;
          this.$message({ type: "error", message: this.$t('Bir_səhv_baş_verdi') });
        }
      },

      getClaimParticipant() {
        GetClaimParticipant(this.id).then((response) => {
          if (response.data) {
            this.claimParticipants = response.data.data?.[0] || {};
          } else {
            this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
          }
        });
      },

      async lastClaimStatus() {
        try {
          const response = await LastClaimStatus(this.id);
          if (response) this.claimStatus = response.data;
          else this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
        } catch (error) {
          this.$message({ type: "error", message: this.$t('Bir_səhv_baş_verdi') });
        }
      },

      handleCommand(command) {
        const id = command.row.id;
        if (command.action === "delete") this.handleDelete(id);
      },

      handleDelete(id) {
        this.$confirm(this.$t('Sənəd_növü_ləğv_olunsun'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t("Xeyr"),
          confirmButtonText: this.$t('Bəli'),
          type: "error",
        })
          .then(() => {
            this.loading = true;
            DeleteClaimDoc(id).then((response) => {
              this.loading = false;
              if (response.data) {
                if (!response.data.isSuccess) {
                  this.$message({ type: "error", message: response.data.errors[0] });
                } else {
                  this.$message({ type: "success", message: this.$t('Ləğv_olundu') });
                  // sende getClaimDocs yok; dokunmuyorum
                }
              } else {
                this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
              }
            });
          })
          .catch(() => {
            this.$message({ type: "info", message: "Xitam verildi" });
          });
      },
    },
    mounted() {
      this.getData();
    },
  };
</script>

<style lang="scss" scoped>
  .btn-margin {
    margin-left: 10px;
  }
</style>
